import { render } from "./problem.vue?vue&type=template&id=6e643e12&scoped=true"
import script from "./problem.vue?vue&type=script&lang=js"
export * from "./problem.vue?vue&type=script&lang=js"

import "./problem.vue?vue&type=style&index=0&id=6e643e12&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e643e12"]])

export default __exports__